// SW-95: the auth payload's role shape has drifted over time — tolerate
// both the nested `userRoles: [{ role: { name } }]` form (the real shape
// of `User.userRoles` — see types/auth.ts) and a flat `roles: string[]`
// some call sites assumed but the User type never actually has, which
// silently broke role checks that only looked at `.roles`
// (ProtectedRoute.tsx's isAgent check always evaluated to false).
export const userHasRole = (user: unknown, roleName: string): boolean => {
  if (!user || typeof user !== 'object') return false;
  const u = user as Record<string, unknown>;

  const userRoles = u.userRoles;
  if (Array.isArray(userRoles)) {
    if (userRoles.some((ur) => {
      const r = ur as { name?: string; role?: { name?: string } };
      return (r?.role?.name ?? r?.name) === roleName;
    })) {
      return true;
    }
  }

  const roles = u.roles;
  if (Array.isArray(roles) && roles.includes(roleName)) return true;

  return false;
};
